import {
    EuiBadge, EuiBreadcrumbs,
    EuiButton,
    EuiEmptyPrompt,
    EuiInMemoryTable,
    EuiLink, EuiPageContent, EuiPageContentHeader, EuiPageContentHeaderSection, EuiPanel,
    EuiSearchBar, EuiSpacer,
    EuiSuperDatePicker, EuiText, EuiTitle
} from "@elastic/eui";
import React, {Fragment, useContext, useEffect, useState} from "react";
import {Store} from "../../../app/stores/store-root";
import {observer} from "mobx-react-lite";
import {Order} from "../../../app/models/order";
import {EuiSearchBarProps} from "@elastic/eui/src/components/search_bar/search_bar";
import {SearchFilterConfig} from "@elastic/eui/src/components/search_bar/search_filters";
import {NavLink, useHistory} from "react-router-dom";
import * as _ from 'lodash'

const OrdersSearch = () => {
    const [selection, setSelection] = useState([]);
    const [branches, setBranches]=useState<any[]>([]);
    const [agents, setAgents]=useState<any[]>([]);
    const [loading, setLoading]=useState(false);

    const onTimeChange = (props: any) => {
        console.log(props);
        setQuery(`CreatedAt:${props.start}`);
    };
    const history=useHistory();

    const [query, setQuery] = useState('');
    const store = useContext(Store);
    useEffect(() => {
        setLoading(true);
        store.Lookups.loadLookups().then(()=>{
            const transformed = store.Lookups.branchRegistry.map((item)=>{return {"value":item.value, "name":item.label}});
            setBranches(transformed);
        }).finally(()=>{
        });

        store.Orders.LoadAllOrders().then(() => {
            const transformed = _.uniqBy(store.Orders.Orders.map((item:Order)=>{return {'value':item.CreatedByName, 'name':item.CreatedByName}}),item=>item.value);
            setAgents(transformed);
        }).finally(()=>        setLoading(false));
    }, [])

    const [message, setMessage] = useState(
        <EuiEmptyPrompt
            iconType="editorStrike"
            title={<h2>No Orders fits the search criteria</h2>}
            body={
                <Fragment>


                </Fragment>
            }
            actions={
                <EuiButton color="primary" fill>
                    Load orders
                </EuiButton>
            }
        />
    );

    const fields = [
        {
        field: 'Reference',
        name: 'Reference',
        sortable: true,
        truncateText: true,
        render: (reference: string) => {
            return (<NavLink to={`orders/edit/${reference}`}>
                {reference}
            </NavLink>)
        }
    },
        {
            field: 'SendingAmount',
            name: 'Sending Amount',
            truncateText: true,
            render: (value: any, item: Order) => {
                return `${item.SendingCurrencySymbol} ${value}`
            }

        },
        {
            field: 'ReceivingAmount',
            name: 'Receiving',
            truncateText: true,
            render: (value: any, item: Order) => {
                return `${item.ReceivingCurrencySymbol} ${value} ${item.ReceivingCurrencyLabel}`
            }

        },
        {
            field: 'ExchangeRate',
            name: 'Rate',
            truncateText: true,
            render:(value:any, item:Order)=>{
                if(value===0)
                    return <EuiBadge color={'#0000FF'}>{`Fees : ${item.Fees}`}</EuiBadge>
                return value
            }
        },
        {
            field: 'CreatedByName',
            name: 'Created By',
            truncateText: true,
        },
        {
            field: 'DeliveryOffice',
            name: 'Branch',
            truncateText: true
        },
        {
            field: 'DeliveryType',
            name: 'Trasnfer Type',
            truncateText: true,
            render: (type: string) => {
                if (type==='0')
                    return <EuiBadge color="#FFA500">Bank Transfer</EuiBadge>

                return <EuiBadge color="#BADA55">Cash</EuiBadge>
            }
        }
        ,
        {
            field: 'RemitterName',
            name: 'Remitter',


        },
        {
            field: 'BeneficiaryName',
            name: 'Beneficiary',


        },
        {
            field: 'Status',
            name: 'Status',
            truncateText: true,
            render: (type: any) => {
                if (type === 0)
                    return <EuiBadge color="warning">Pending</EuiBadge>
                if (type === 1)
                    return <EuiBadge color="secondary">Ready</EuiBadge>
                if (type === 2)
                    return <EuiBadge color="primary">Paid</EuiBadge>
                if (type === 3)
                    return <EuiBadge>Rejected</EuiBadge>
                if (type === 4)
                    return <EuiBadge color="danger">Cancelled</EuiBadge>
                if (type === 5)
                    return <EuiBadge color="#FCF7BC">In Progress</EuiBadge>

            }
        },
        {
            field: 'CreatedAt',
            name: 'Created At',
            sortable: true,

        }
    ]

    const searchFilters: SearchFilterConfig[] = [
        {
            type: 'field_value_toggle_group',
            field: 'Status',
            items: [
                {
                    value: 0,
                    name: 'Pending Review'
                },
                {
                    value: 1,
                    name: 'Ready For Collection'
                },
                {
                    value: 2,
                    name: 'Paid'
                },
                {
                    value: 3,
                    name: 'Rejected'
                },
                {
                    value: 4,
                    name: 'Cancelled'
                },
                {
                    value: 5,
                    name: 'In Progress'
                }
            ]
        },
        {
            type: 'field_value_selection',
            field: 'DeliveryOffice',
            name: 'Branch',
            options: branches,
            multiSelect: false
        },
        {
            type: 'field_value_selection',
            field: 'CreatedByName',
            name: 'Sending Agent',
            options: agents,
            multiSelect: false
        },
    ]
    const schema = {
        strict: false,
        fields: {
            'CreatedAt': {
                type: 'date',
            },
        }
    };
    const searchSettings: EuiSearchBarProps = {
        box: {
            incremental: true,
            schema: true,
            placeholder: ''
        },
        filters: searchFilters
    }
    const selectionValue = {
        selectable: (order: any) => true,
        initialSelected: selection,
        onSelectionChange: (selection: any) => {
            setSelection(selection);
            console.log(selection);
        },
    };
    const breadcrumbs = [
        {
            text: 'Remittance App',
            href: '#',
            onClick: (e: any) => {
                e.preventDefault();
            },
            'data-test-subj': 'breadcrumbsAnimals',
        },
        {
            text: 'Transfer Orders',
            href: '#',
            onClick: (e: any) => {
                e.preventDefault();
            },
        },
    ];
    return (
<Fragment>
    <EuiPageContent>
        <EuiBreadcrumbs
            breadcrumbs={breadcrumbs}
            truncate={false}
            aria-label="An example of EuiBreadcrumbs"
        />
        <EuiSpacer size="xs"/>
        <EuiPageContentHeader>
            <EuiPageContentHeaderSection>
                <EuiText>
                    <h1>Transfer Orders Search</h1>
                    <p>
                    </p>
                </EuiText>
            </EuiPageContentHeaderSection>
            <EuiPageContentHeaderSection>
                <EuiButton onClick={()=>{
history.push('/orders/create')
                }} color={'secondary'}>New Order Transfer</EuiButton>
            </EuiPageContentHeaderSection>
        </EuiPageContentHeader>

    </EuiPageContent>
    <EuiSpacer/>
    <EuiPanel hasShadow={true} paddingSize={'l'}>
        {/* <EuiSuperDatePicker onTimeChange={onTimeChange}/>
            <EuiSearchBar query={query}/>*/}
        <EuiInMemoryTable items={store.Orders.Orders} pagination={true} columns={fields} sorting={true}
                          search={searchSettings} isSelectable={true} selection={selectionValue}
                          itemId="Reference" message={message}
                          loading={loading}
        />
    </EuiPanel>
</Fragment>


    );
};

export default observer(OrdersSearch)
